import { render, staticRenderFns } from "./SefosMessage.vue?vue&type=template&id=11ed68f8&"
import script from "./SefosMessage.vue?vue&type=script&lang=js&"
export * from "./SefosMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ed68f8')) {
      api.createRecord('11ed68f8', component.options)
    } else {
      api.reload('11ed68f8', component.options)
    }
    module.hot.accept("./SefosMessage.vue?vue&type=template&id=11ed68f8&", function () {
      api.rerender('11ed68f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/Message/SefosMessage.vue"
export default component.exports